export default {
    "openingScreen": {
    "message": "CrxMouse の使い方を学びましょう",
        "description": "Start game screen. Sentence finishes with the words - The Mouse Chase"
},
    "startGame": {
    "message": "ゲームを開始する",
        "description": "Start game option - on screen 1"
},
    "settings": {
    "message": "CrxMouse の設定",
        "description": "Settings option. Don't translate the word - CrxMouse - on screen 1 and 6"
},
    "gestureList": {
    "message": "ジェスチャーリスト",
        "description": "Gesture list option - on screen 1 and 6"
},
    "playLater": {
    "message": "後でプレイする",
        "description": "Play later option - on screen 1"
},
    "playAgain": {
    "message": "もう一度プレイする",
        "description": "Play again option - on screen 6"
},
    "startGameScreen0": {
    "message": "ゲームを開始するには",
        "description": "First sentence of the first screen for users that don't have CrxMouse installed - on screen 0"
},
    "firstGestureInstructionDownload": {
    "message": "Chrome に CrxMouse をダウンロードする",
        "description": "CrxMouse is available on Chrome extension store. This is the CTA that sends the user to CrxMouse on Chrome. Do not translate the word - CrxMouse - on screen 0"
},
    "firstDownloadNow": {
    "message": "今すぐダウンロードする",
        "description": "CTA to download CrxMouse - on screen 0"
},
    "gestureInstructions1": {
    "message": "マウスジェスチャーを使用してスクロールダウンする",
        "description": "gesture instructions on screen 1 of the game"
},
    "gameReference1": {
    "message": "***チェイスを始める***",
        "description": "reference to the mouse chase game on screen 1 of the game"
},
    "movementInstructions1": {
    "message": "画面上の任意の場所を<span class='yellow-text'>右クリック</span> ＋ 少し<span class='yellow-text'>下</span>にドラッグ ＋ 放す",
        "description": "movement instructions on screen 1 of the game"
},
    "gestureInstructions2": {
    "message": "スーパードラッグジェスチャーを使用して新しいタブでリンクを開く",
        "description": "gesture instructions on screen 2 of the game"
},
    "gameReference2": {
    "message": "モンスターから逃げて！！！",
        "description": "reference to the mouse chase game on screen 2 of the game"
},
    "movementInstructions2Part1": {
    "message": "<span class='yellow-text'>このリンク</span>を",
        "description": "movement instructions on screen 1 of the game - part 1 of the sentence"
},
    "movementInstructions2Part2": {
    "message": "<a class='blue-link' href='/the-mouse-chase-2' target='_blank'>左クリック</a>",
        "description": "movement instructions on screen 1 of the game - part 2 of the sentence"
},
    "movementInstructions2Part3": {
    "message": " ＋ 少し<span class='yellow-text'>右</span>にドラッグ ＋ 放す",
        "description": "movement instructions on screen 1 of the game - part 3 of the sentence"
},
    "gestureInstructions3": {
    "message": "マウスジェスチャーを使用して左のタブに移動する",
        "description": "gesture instructions on screen 3 of the game"
},
    "gameReference3": {
    "message": "戻って！王女が危険にさらされています",
        "description": "reference to the mouse chase game on screen 3 of the game"
},
    "movementInstructions3": {
    "message": "画面上の任意の場所を<span class='yellow-text'>右クリック</span> ＋ マウスを少し<span class='yellow-text'>上＆左</span>にドラッグ ＋ 放す",
        "description": "movement instructions on screen 3 of the game"
},
    "gestureInstructions4": {
    "message": "マウスジェスチャーを使用してこのページの上部にスクロールする",
        "description": "gesture instructions on screen 4 of the game"
},
    "gameReference4": {
    "message": "猫を倒して王女のもとへ行きましょう！",
        "description": "reference to the mouse chase game on screen 4 of the game"
},
    "movementInstructions4": {
    "message": "画面上の任意の場所を<span class='yellow-text'>右クリック</span> ＋ 少し<span class='yellow-text'>右＆上</span>にドラッグ ＋ 放す",
        "description": "movement instructions on screen 4 of the game"
},
    "gestureInstructions5": {
    "message": "スーパードラッグジェスチャーを使用して画像を保存する",
        "description": "gesture instructions on screen 5 of the game"
},
    "gameReference5": {
    "message": "おめでとうございます！王女を救出しました",
        "description": "reference to the mouse chase game on screen 5 of the game"
},
    "movementInstructions5": {
    "message": "王女の画像上で<span class='yellow-text'>左クリック</span>＋ 少し<span class='yellow-text'>下</span>にドラッグ ＋ 放す",
        "description": "movement instructions on screen 5 of the game"
},
    "fifthFinishGame": {
    "message": "ゲームを終了するにはここをクリック",
        "description": "A CTA the user needs to click in order to finish the game."
},
    "sixthCongratulations": {
    "message": "<span class='white-text'>おめでとうございます！</span>",
        "description": "The last screen of the game when the user is congratualated for finishing the game."
},
    "sixthCrxChampion": {
    "message": "<br>CrxMouse チャンピオンになりました。",
        "description": "When translating, try to find the corresponding phrase for the phrase - CrxMouse champion, without translating the word - CrxMouse."
},
    "soundOn": {
    "message": "サウンドをオンにする",
        "description": "instructions next to the sound icon when it's off"
},
    "soundOff": {
    "message": "サウンドをオフにする",
        "description": "instructions next to the sound icon when it's on"
},
    "hearts": {
    "message": "プレイしてハートを獲得しましょう",
        "description": "headline of hearts section"
},
    "firstExistPopuptitle": {
    "message": "まだ行かないで！",
        "description": "title of exit popup"
},
    "firstExistPopupSubtitle": {
    "message": "マウスジェスチャーの使い方を学ぶチャンスです。",
        "description": "subtitle of  of exit popup"
},
    "firstExistPopupSubSubtitle": {
    "message": "（そして悪い猫から王女を救出してください...）",
        "description": "sub-subtitle of  of exit popup"
},
    "firstExitPopupCTA1": {
    "message": "ゲームを開始する",
        "description": "First CTA of first exit popup"
},
    "exitPopupsCTA2": {
    "message": "代わりにチュートリアルを見る",
        "description": "Second CTA of the exit popups"
},
    "exitPopupsCTA3": {
    "message": "CrxMouse の設定に移動する",
        "description": "Third CTA of the exit popups"
},
    "secondExistPopupCTA1": {
    "message": "ゲームを続ける",
        "description": "subtitle of the second exit popup"
},
    "needHelpPopupTitle": {
    "message": "お困りですか？",
        "description": "Title of the 'need help' popup"
},
    "needHelpPopupSubtitle": {
    "message": "ゲームプレイの動画を見る",
        "description": "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
},
    "needHelpPopupClose": {
    "message": "閉じる",
        "description": "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
},
    "settingsIcon": {
    "message": "設定",
        "description": "text next to settings icon - appears in all screens"
},
    "secondExistPopupSubtitle": {
    "message": "また $NUMBER$ 個のジェスチャーの学習が終わっていません",
        "description": "subtitle of the second exit popup",
        "placeholders": {
        "number": {
            "content": "$1"
        }
    }
  }
}
